/** Sidebar icons: the shared Icon set at nav weight. */

import { Icon } from "../components/ui/Icon.jsx";

export function NavIcon({ name, className = "" }) {
  return <Icon name={name} className={`size-[18px] ${className}`} strokeWidth={1.5} />;
}
